import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './desarrollo_utils';

export const useDesarrolloStore = defineStore('desarrolloStore', {
  state: () => ({
    desarrollos: [],
    page: 1,
    isLoading: false,
    loaded: false,
    lastParams: null,
    filters: {},
  }),
  actions: {
    async findFit({ MedidaDesarrollo, Tolerancia, ToleranciaMin }) {
      this.isLoading = true; // Inicio de carga
      const result = await api.get(
        `/desarrollo/fit?MedidaDesarrollo=${MedidaDesarrollo}&Tolerancia=${Tolerancia}&ToleranciaMin=${ToleranciaMin}`,
      );
      if (result && result.data) {
        this.isLoading = false; // Fin de la carga, independientemente del resultado
        return result.data;
      }
    },
    async findAllDesarrollos(params = {}) {
      const key = JSON.stringify(params);
      if (this.loaded && this.lastParams === key) {
        return true;
      }

      this.isLoading = true;
      this.lastParams = key;

      try {
        const result = await api.get(
          `/desarrollo?${getParamsUrl({ page: 1, ...this.filters, ...params })}`,
        );

        if (result?.data) {
          this.desarrollos = result.data;
          this.loaded = true;
          return true;
        }

        return false;
      } finally {
        this.isLoading = false;
      }
    },
    async searchDesarrolloHTTP(query) {
      const url = `/desarrollo/engranaje?Engranaje=${query}&page=1`;
      try {
        const result = await api.get(url);
        if (result && result.data && result.data.length > 0) {
          return [...result.data];
        }
        return [];
      } catch (error) {
        console.error('Error al buscar desarrollos:', error);
        throw error;
      }
    },
    async findAll() {
      const result = await api.get('/desarrollo', { params: { page: +this.page } });
      if (result && result.data) {
        return result.data;
      }
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.desarrollos = [];
    },
  },
});
